import React, {Component, ReactElement, RefObject} from 'react'
import {NatGetResidentUserAuthed} from '../residentUser/repository/NatGetResidentUserAuthed'
import NatResidentUserRepo, {UpdateResidentUserLoginedRequest} from '../residentUser/repository/NatResidentUserRepo'
import {Messages} from '../../../Messages'
import {
    BaseBasePersonalMainTitleArea,
    BasePersonalDescriptionInnerTxt,
    BasePersonalDescriptionWrapper,
    BasePersonalMainTitle,
    BasePersonalSubTitleInnerTxt,
    BasePersonalSubTitleWrapper,
    BasePersonalTitleBorder,
    BasePersonalWarraper,
} from './NatResidentPersonalSettingPage'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {BreakPoint, Colors, FontSize} from '../../../styledComponents/Constants'
import {generateMedia} from 'styled-media-query'
import {MainContainer, Note} from '../../../styledComponents/ContentsArea'
import {
    DisplayBlockDiv,
    DisplayItemDiv,
    DisplayItemInput,
    DisplayItemInputLabel,
    DisplayItemInputLabelRequired,
    DisplayItemInputTitleRequired,
    FieldErrorLabel,
} from '../../../styledComponents/DisplayItem'
import NatDialogComponent from '../common/resident/NatDialogComponent'
import {Nullable} from '../../../app/TypeHelpers'
import {PrimaryStyledButton, SecondaryButton} from '../../../styledComponents/Button'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {RequestItemError} from '../../../network/response/RequestItemError'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {autoKanaOnUpdate, convertToRoomNumberForResident, NatAsyncCallFunction} from '../../common/util/Natutil'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const SELECTED_ROOM_NUMBER: string = 'selectedRoomNumber'
const SELECTED_RIDGE_NAME: string = 'selectedRidgeName'
const KEY_LOGIN_FAMILY_NAME: string = 'loginFamilyName'
const KEY_LOGIN_FIRST_NAME: string = 'loginFirstName'

interface FieldsError {
    familyName: Error[]
    firstName: Error[]
    familyNameKana: Error[]
    firstNameKana: Error[]
}

interface Error {
    message: string
    hasError: boolean
}

type Field = 'familyName' | 'firstName' | 'familyNameKana' | 'firstNameKana'


interface Props {
    residentUserRepo: NatResidentUserRepo,
    location: Location,
}

interface States {
    ridgeName: string | null
    roomNumber: string | null
    familyNameValue: string
    firstNameValue: string
    familyNameKanaValue: string
    firstNameKanaValue: string
    changeButtonDisabled: boolean
    version: number
    dialogOpen: boolean
    dialogBackOpen: boolean
    fieldsError: Partial<FieldsError>,
    isLoadCompleted: boolean
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

class NatResidentChangeUserNamePage extends Component<Props & ResidentPagePropsSet, States> {
    autoFocus: RefObject<HTMLInputElement>

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        const ridgeName: string | null = window.sessionStorage.getItem(SELECTED_RIDGE_NAME)
        const roomNumber: string | null = window.sessionStorage.getItem(SELECTED_ROOM_NUMBER)
        this.state = {
            ridgeName: ridgeName,
            roomNumber: roomNumber,
            familyNameValue: '',
            firstNameValue: '',
            familyNameKanaValue: '',
            firstNameKanaValue: '',
            changeButtonDisabled: true,
            version: 0,
            dialogOpen: false,
            dialogBackOpen: false,
            fieldsError: {},
            isLoadCompleted: false,
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
        }
        this.autoFocus = React.createRef()
        this.onChangeFamilyName = this.onChangeFamilyName.bind(this)
        this.onChangeFirstName = this.onChangeFirstName.bind(this)
        this.onChangeFamilyNameKana = this.onChangeFamilyNameKana.bind(this)
        this.onChangeFirstNameKana = this.onChangeFirstNameKana.bind(this)
        this.handleProfileSettingButtonClick = this.handleProfileSettingButtonClick.bind(this)
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleBackOkClick = this.handleBackOkClick.bind(this)
        this.handleBackCancelClick = this.handleBackCancelClick.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        let retResidentUser: Nullable<NatGetResidentUserAuthed> = null
        try {
            // ユーザ情報取得
            retResidentUser = await NatAsyncCallFunction(
                this.props.residentUserRepo.getResidentUserLogined.bind(
                    this.props.residentUserRepo), this.props.navigate)

            if (retResidentUser && retResidentUser.details !== null) {
                this.setState({
                    familyNameValue: retResidentUser.details.familyName,
                    firstNameValue: retResidentUser.details.firstName,
                    familyNameKanaValue: retResidentUser.details.familyNameKana,
                    firstNameKanaValue: retResidentUser.details.firstNameKana,
                    version: retResidentUser.details.version,
                })

            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

        if (this.autoFocus.current) {
            this.autoFocus.current.focus()
            window.scrollTo(0, 0)
        }
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.familyNameKanaValue ?? '',
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.firstNameKanaValue ?? '',
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }

    onChangeFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        let changeButtonDisabled: boolean = false
        const familyNameKanaValue = this.state.convertFamilyNameKana
        if (event.target.value !== '' && familyNameKanaValue !== '' &&
            this.state.firstNameValue !== '' && this.state.firstNameKanaValue !== '') {
            changeButtonDisabled = true
        }
        this.setState({
            familyNameValue: event.target.value,
            familyNameKanaValue: event.target.value ? familyNameKanaValue : '',
            changeButtonDisabled: changeButtonDisabled,
        })
    }

    onChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        let changeButtonDisabled: boolean = false
        const firstNameKanaValue = this.state.convertFirstNameKana
        if (event.target.value !== '' && firstNameKanaValue !== '' &&
            this.state.familyNameValue !== '' && this.state.familyNameKanaValue !== '') {
            changeButtonDisabled = true
        }

        this.setState({
            firstNameValue: event.target.value,
            firstNameKanaValue: event.target.value ? firstNameKanaValue : '',
            changeButtonDisabled: changeButtonDisabled,
        })
    }

    onChangeFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value !== '' && this.state.familyNameValue !== '' &&
            this.state.firstNameValue !== '' && this.state.firstNameKanaValue !== '') {
            this.setState({changeButtonDisabled: true})
        } else {
            this.setState({changeButtonDisabled: false})
        }
        this.setState({familyNameKanaValue: event.target.value})
    }

    onChangeFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value !== '' && this.state.familyNameValue !== '' &&
            this.state.familyNameKanaValue !== '' && this.state.firstNameValue !== '') {
            this.setState({changeButtonDisabled: true})
        } else {
            this.setState({changeButtonDisabled: false})
        }
        this.setState({firstNameKanaValue: event.target.value})
    }

    handleBackButtonClick(): void {
        this.setState({dialogBackOpen: true})
    }

    handleProfileSettingButtonClick(): void {
        this.setState({dialogOpen: true})
    }

    handleRegisterCancelClick(): void {
        this.setState({dialogOpen: false})
    }

    handleBackCancelClick(): void {
        this.setState({dialogBackOpen: false})
    }

    async handleRegisterOkClick(): Promise<void> {
        await this.clearMessage()
        this.setState({dialogOpen: false})

        await this.props.eventEmitter.showLoading()
        try {
            const request: UpdateResidentUserLoginedRequest = {
                familyName: this.state.familyNameValue,
                firstName: this.state.firstNameValue,
                familyNameKana: this.state.familyNameKanaValue,
                firstNameKana: this.state.firstNameKanaValue,
                version: this.state.version,
            }

            // 居住者ユーザ更新
            const ret: Nullable<void> = await NatAsyncCallFunction(
                this.props.residentUserRepo.updateResidentUserLogined.bind(
                    this.props.residentUserRepo, request), this.props.navigate)

            if (ret) {
                // セッションストレージ更新
                SessionStorageHelper.setItem(KEY_LOGIN_FAMILY_NAME, this.state.familyNameValue)
                SessionStorageHelper.setItem(KEY_LOGIN_FIRST_NAME, this.state.firstNameValue)

                this.props.navigate(
                    `/resident/personalSetting`,
                )
            }
        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                if (errorResponseBody.requestItemErrors.length > 0) {
                    errorResponseBody.requestItemErrors.forEach((item: RequestItemError) => {
                        if (item.fields) {
                            item.fields.forEach((field) => {
                                this.setFieldErrorMessage(field, item.message)
                            })
                        }
                    })
                } else {
                    this.props.navigate(
                        `/resident/error`,
                        {
                            state: {
                                message: errorResponseBody.requestError.message,
                            },
                        },
                    )
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackOkClick(): void {
        this.props.navigate(`/resident/personalSetting`)
    }

    getDialogComponent(): ReactElement | null {
        return (
            <NatDialogComponent
                open={this.state.dialogOpen}
                params={{
                    title: '確認',
                    errorLevel: Messages.IOPCC0012.errorLevel,
                    message: Messages.IOPCC0012.toString('プロフィール情報'),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.handleRegisterCancelClick,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleRegisterOkClick,
                        },
                    ],
                }}
            />
        )
    }

    getDialogBackComponent(): ReactElement | null {
        return (
            <NatDialogComponent
                open={this.state.dialogBackOpen}
                params={{
                    title: '確認',
                    errorLevel: Messages.WOPCC0001.errorLevel,
                    message: Messages.WOPCC0001.toString(''),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.handleBackCancelClick,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleBackOkClick,
                        },
                    ],
                }}
            />
        )
    }

    // メッセージ設定（フィールド）
    setFieldErrorMessage(field: string, message: string): void {
        if (field === 'familyName' || field === 'firstName' ||
            field === 'familyNameKana' || field === 'firstNameKana') {
            let error: Error[] | undefined = this.state.fieldsError[field]
            if (error === undefined) {
                error = [{message: message, hasError: true}]
            } else {
                error.push({message: message, hasError: true})
            }
            ReactDOM.flushSync(() => {
                this.setState(({fieldsError}) => (
                    {
                        fieldsError: {
                            ...fieldsError,
                            [field]: error,
                        },
                    }))
            })
        }
    }

    // メッセージ取得（フィールド）
    getFieldErrorMessage(fieldId: Field): Nullable<ReactElement> {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        if (field !== undefined) {
            return (
                <>
                    {field.map((error, index) => (
                        <FieldErrorLabel key={index}>
                            {error.message}
                        </FieldErrorLabel>
                    ))}
                </>
            )
        } else {
            return null
        }
    }

    // フィールドエラー状態取得
    getFieldErrorStatus(fieldId: Field): boolean {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        return !!(field !== undefined && field[0] !== undefined && field[0].hasError)
    }

    // メッセージクリア
    clearMessage(): void {
        this.setState({fieldsError: {}})
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <BasePersonalWarraper>
                <PersonalProfileArea>
                    <BasePersonalMainTitle>
                        <BasePersonalTitleBorder>
                            個人設定
                        </BasePersonalTitleBorder>
                    </BasePersonalMainTitle>
                </PersonalProfileArea>
                <Border/>
                <BasePersonalSubTitleWrapper>
                    <BasePersonalSubTitleInnerTxt>
                        プロフィール情報の変更
                    </BasePersonalSubTitleInnerTxt>
                </BasePersonalSubTitleWrapper>
                <PersonalProfileDescription>
                    <BasePersonalDescriptionInnerTxt>
                        ご登録いただいている情報の変更ができます。
                    </BasePersonalDescriptionInnerTxt>
                    <BasePersonalDescriptionInnerTxt>
                        変更する場合は、変更したい箇所のみ書き換えて「変更する」ボタンを押してください。
                    </BasePersonalDescriptionInnerTxt>
                </PersonalProfileDescription>
                <MainContainer>
                    <DisplayBlockDiv>
                        <DisplayItemInputLabel>部屋番号</DisplayItemInputLabel>
                        <DisplayItemDiv>
                            {this.state.ridgeName} {convertToRoomNumberForResident(this.state.roomNumber)}
                        </DisplayItemDiv>
                        <Note>{Messages.IRESR0006.toString('')}</Note>
                    </DisplayBlockDiv>
                    <DisplayBlockDiv>
                        <DisplayItemInputLabelRequired>
                            <DisplayItemInputTitleRequired>氏名</DisplayItemInputTitleRequired>
                        </DisplayItemInputLabelRequired>
                        <BlockFormDetail>
                            <InputLabel>姓</InputLabel>
                            <DisplayItemDetailsInput
                                type="text"
                                id="familyName"
                                name="familyName"
                                maxLength={10}
                                value={this.state.familyNameValue}
                                onInput={this.onChangeFamilyName}
                                onChange={this.onChangeFamilyName}
                                onCompositionStart={this.onCompositionStartFamilyName}
                                onCompositionUpdate={this.onCompositionUpdateFamilyName}
                                hasError={this.getFieldErrorStatus('familyName')}
                                ref={this.autoFocus}

                            />
                        </BlockFormDetail>
                        {this.getFieldErrorMessage('familyName')}
                        <BlockFormDetail>
                            <InputLabel>名</InputLabel>
                            <DisplayItemDetailsInput
                                type="text"
                                id="firstName"
                                name="firstName"
                                maxLength={10}
                                value={this.state.firstNameValue}
                                onInput={this.onChangeFirstName}
                                onChange={this.onChangeFirstName}
                                onCompositionStart={this.onCompositionStartFirstName}
                                onCompositionUpdate={this.onCompositionUpdateFirstName}
                                hasError={this.getFieldErrorStatus('firstName')}
                            />
                        </BlockFormDetail>
                        {this.getFieldErrorMessage('firstName')}
                        <DisplayItemInputLabelRequired>
                            <DisplayItemInputTitleRequired>フリガナ</DisplayItemInputTitleRequired>
                        </DisplayItemInputLabelRequired>
                        <BlockFormDetail>
                            <InputLabel>セイ</InputLabel>
                            <DisplayItemDetailsInput
                                type="text"
                                id="familyNameKana"
                                name="familyNameKana"
                                value={this.state.familyNameKanaValue}
                                maxLength={20}
                                onInput={this.onChangeFamilyNameKana}
                                onChange={this.onChangeFamilyNameKana}
                                hasError={this.getFieldErrorStatus('familyNameKana')}
                            />
                        </BlockFormDetail>
                        {this.getFieldErrorMessage('familyNameKana')}
                        <BlockFormDetail>
                            <InputLabel>メイ</InputLabel>
                            <DisplayItemDetailsInput
                                type="text"
                                id="firstNameKana"
                                name="firstNameKana"
                                value={this.state.firstNameKanaValue}
                                maxLength={20}
                                onInput={this.onChangeFirstNameKana}
                                onChange={this.onChangeFirstNameKana}
                                hasError={this.getFieldErrorStatus('firstNameKana')}
                            />
                        </BlockFormDetail>
                        {this.getFieldErrorMessage('firstNameKana')}
                    </DisplayBlockDiv>
                    <DisplayBlockDiv>
                        <SecondaryButton onClick={this.handleBackButtonClick}>前に戻る</SecondaryButton>
                    </DisplayBlockDiv>
                    <DisplayBlockDiv>
                        <PrimaryStyledButton
                            onClick={this.handleProfileSettingButtonClick}
                            disabled={!this.state.changeButtonDisabled}>
                            変更する
                        </PrimaryStyledButton>
                    </DisplayBlockDiv>
                </MainContainer>
                {this.getDialogComponent()}
                {this.getDialogBackComponent()}
            </BasePersonalWarraper>
        )
    }
}

export default createResidentPage(NatResidentChangeUserNamePage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const PersonalProfileArea = styled(BaseBasePersonalMainTitleArea)`
  display: none;
  ${breakPoint.lessThan('sp')`
    display: block;
  `}
`

const PersonalProfileDescription = styled(BasePersonalDescriptionWrapper)`
  margin: 0 100px 30px 50px;
  background-color: initial;
`

const BlockFormDetail: StyledDiv = styled.div`
  display: table;
  margin-bottom: 10px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`

const InputLabel: StyledDiv = styled.div`
  display: table-cell;
  width: 50px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  box-shadow: 0 0 0 1px ${Colors.AccentLight} inset;
  text-align: center;
  border-right: none;
  background-color: ${Colors.Background};
  vertical-align: middle;
  font-size: ${FontSize.Small};
`

const DisplayItemDetailsInput = styled(DisplayItemInput)`
  border-radius: 0 4px 4px 0;
  vertical-align: top;
`

const Border: StyledDiv = styled.div`
  display: none;

  ${breakPoint.lessThan('sp')`
    display: block;
    margin: 5px 15px 15px 15px;
    border-top: 1.5px solid ${Colors.AccentLight};
  `}
`

